import { render, staticRenderFns } from "./WhatsAppRedirect.vue?vue&type=template&id=3c5ba4be&scoped=true&"
import script from "./WhatsAppRedirect.vue?vue&type=script&lang=js&"
export * from "./WhatsAppRedirect.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppRedirect.vue?vue&type=style&index=0&id=3c5ba4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5ba4be",
  null
  
)

export default component.exports